module.exports = __webpack_public_path__ + "static/media/AWS_firstPage_en.4e4c6422.png";